import Bugsnag from "@bugsnag/js";
import { environment } from "../../../environments/environment";
import { version } from "../../../../package.json";

export const bugsnagClient = environment.BUGSNAG_KEY
  ? Bugsnag.start({
      apiKey: environment.BUGSNAG_KEY,
      appVersion: version,
      releaseStage: environment.environment,
    })
  : null;
